import { useOutletContext } from "react-router-dom";
import { useState, useEffect } from 'react';

import UserDataForm from './administration/assets/UserDataForm.js';
import { translations } from './../../i18/translations.js';

const MyProfile = () => {

    const API_URL = process.env.REACT_APP_SERVICE_API_URL;

    const {lang, user, showAlert, checkAccess, fetchLoggedUser} = useOutletContext();
    const [selectedMember, setSelectedMember] = useState(null);


    const fetchMyData = async () => {
        try {
            const response = await fetch(`${API_URL}/admin/get_my_data.php`);
            const data = await response.json();
            setSelectedMember(data);
        } catch (error) {
            console.error("Error fetching member data:", error);
        }
    };

    useEffect(() => {
        if (user) {
            fetchMyData();
        }
    }, [user]);

    const onSave = async (baseData) => {
        try {
            const payload = {
                userData: baseData
            };

            const response = await fetch(`${API_URL}/admin/save_my_data.php`, {
                method: 'POST',
                headers: {'Content-Type': 'application/json'},
                body: JSON.stringify(payload)
            });
            const data = await response.json();
            if (checkAccess(data)) {
                showAlert(data.alert);
                await fetchMyData(data.userId);
                fetchLoggedUser();
            }
        } catch (error) {
            console.error("Error fetching my datya:", error);
        }
    };

    return (
            <>
            <h1 className="mbkegy-content">{translations[lang].my_payments_and_profile}</h1>
            <div className="mbkegy-content">
                {selectedMember && <UserDataForm selectedMember={selectedMember} onSave={onSave} onClose={() => {
                                                                 }} fetchMemberData={fetchMyData}  adminMode={false}/>}            
            </div>
            </>
            );
};

export default MyProfile;